module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Sort</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 nopadding-r\">\r\n        <select name=\"sortOrder\" id=\"sortOrder\" style=\"width: 100%;\">\r\n            <option value=\"group\">Group</option>\r\n            <option value=\"value\">Value</option>\r\n        </select>\r\n    </div>\r\n    <div class=\"col-md-6 nopadding-r\">\r\n        <select name=\"sortType\" id=\"sortType\" style=\"width: 100%;\">\r\n            <option value=\"none\">None</option>\r\n            <option value=\"asc\">Ascending</option>\r\n            <option value=\"desc\">Descending</option>\r\n        </select>\r\n    </div>\r\n</div>")
  }
  return __output;

}